export const mobileImages = [
  `Header_Background_Images/A32332_541_3_RGB_alt 1.jpg`,
  `Header_Background_Images/GiftImage.jpg`,
  `Header_Background_Images/mobile_bg1.jpg`,
  `Header_Background_Images/mobile_bg2.jpg`,
  `Header_Background_Images/mobile_bg3.jpg`,
  `Header_Background_Images/mobile_bg4.jpg`,
  `Header_Background_Images/mobile_bg5.jpg`,
  `Header_Background_Images/PL00501381.jpg`,
  `Header_Background_Images/PL00502034.jpg`,
  `Header_Background_Images/PL00531841.jpg`,
  `Header_Background_Images/PL00532423.jpg`,
  `Header_Background_Images/PL00534029.jpg`,
  `Header_Background_Images/PL00537533.jpg`,
  `Header_Background_Images/PL00539007.jpg`,
  `Header_Background_Images/PL00542964.jpg`,
  `Header_Background_Images/PL00548445.jpg`,
  `Header_Background_Images/PL00550649.jpg`,
  `Header_Background_Images/PL00551469_alt.jpg`,
  `Header_Background_Images/PL00551659.jpg`,
  `Header_Background_Images/PL00551798_alt.jpg`,
  `Header_Background_Images/PL00557134.jpg`,
  `Header_Background_Images/PL00558512.jpg`,
  `Header_Background_Images/PL00558922.jpg`,
  `Header_Background_Images/PL00565608_BW.jpg`,
  `Header_Background_Images/PL00569380_WORK.jpg`,
  `Header_Background_Images/PL00569402_WORK.jpg`,
  `Header_Background_Images/PL00574873.jpg`,
  `Header_Background_Images/PL00635064.jpg`,
  `Header_Background_Images/PL00651565.jpg`,
  `Header_Background_Images/PL00651636_WORK.jpg`,
  `Header_Background_Images/PL00651639-1.jpg`,
  `Header_Background_Images/PL00658492_alt.jpg`,
  `Header_Background_Images/PL00659296.jpg`,
  `Header_Background_Images/PL00663023.jpg`,
  `Header_Background_Images/PL00671553.jpg`,
  `Header_Background_Images/PL00706621.jpg`,
  `Header_Background_Images/Mountain-08.jpg`,
  `Header_Background_Images/Beach-22.jpg`,
  `Header_Background_Images/Estate-02.jpg`,
`Header_Background_Images/Gifting-01.jpg`,
`Header_Background_Images/Estate-03.jpg`,
`Header_Background_Images/Beach-23.jpg`,
`Header_Background_Images/Mountain-09.jpg`,
`Header_Background_Images/Beach-09.jpg`,
`Header_Background_Images/Beach-21.jpg`,
`Header_Background_Images/Estate-01.jpg`,
`Header_Background_Images/Gifting-03.jpg`,
`Header_Background_Images/Gifting-02.jpg`,
`Header_Background_Images/Beach-20.jpg`,
`Header_Background_Images/Beach-08.jpg`,
`Header_Background_Images/Americana-08.jpg`,
`Header_Background_Images/Beach-24.jpg`,
`Header_Background_Images/Beach-18.jpg`,
`Header_Background_Images/Estate-04.jpg`,
`Header_Background_Images/Fabric-01.jpg`,
`Header_Background_Images/Gifting-06.jpg`,
`Header_Background_Images/Gifting-07.jpg`,
`Header_Background_Images/Estate-05.jpg`,
`Header_Background_Images/Beach-19.jpg`,
`Header_Background_Images/Beach-25.jpg`,
`Header_Background_Images/Americana-09.jpg`,
`Header_Background_Images/Beach-27.jpg`,
`Header_Background_Images/Estate-07.jpg`,
`Header_Background_Images/Gifting-05.jpg`,
`Header_Background_Images/Gifting-04.jpg`,
`Header_Background_Images/Estate-06.jpg`,
`Header_Background_Images/Beach-26.jpg`,
`Header_Background_Images/Resort-07.jpg`,
`Header_Background_Images/Paris-06.jpg`,
`Header_Background_Images/Lake-02.jpg`,
`Header_Background_Images/Lake-03.jpg`,
`Header_Background_Images/Suiting-06.jpg`,
`Header_Background_Images/Resort-06.jpg`,
`Header_Background_Images/Paris-05.jpg`,
`Header_Background_Images/Suiting-04.jpg`,
`Header_Background_Images/Lake-01.jpg`,
`Header_Background_Images/Suiting-05.jpg`,
`Header_Background_Images/Paris-04.jpg`,
`Header_Background_Images/Resort-05.jpg`,
`Header_Background_Images/Suiting-01.jpg`,
`Header_Background_Images/Lake-04.jpg`,
`Header_Background_Images/Lake-05.jpg`,
`Header_Background_Images/Paris-01.jpg`,
`Header_Background_Images/Equestian-01.jpg`,
`Header_Background_Images/Equestian-03.jpg`,
`Header_Background_Images/Paris-03.jpg`,
`Header_Background_Images/Suiting-02.jpg`,
`Header_Background_Images/NYC-09.jpg`,
`Header_Background_Images/Lake-07.jpg`,
`Header_Background_Images/Lake-06.jpg`,
`Header_Background_Images/NYC-08.jpg`,
`Header_Background_Images/Suiting-03.jpg`,
`Header_Background_Images/Paris-02.jpg`,
`Header_Background_Images/Equestian-02.jpg`,
`Header_Background_Images/Store-04.jpg`,
`Header_Background_Images/NYC-05.jpg`,
`Header_Background_Images/Nautical-01.jpg`,
`Header_Background_Images/NYC-04.jpg`,
`Header_Background_Images/NYC-10.jpg`,
`Header_Background_Images/Garden-02.jpg`,
`Header_Background_Images/Store-05.jpg`,
`Header_Background_Images/Collegiate-04.jpg`,
`Header_Background_Images/Store-07.jpg`,
`Header_Background_Images/NYC-06.jpg`,
`Header_Background_Images/Lake-08.jpg`,
`Header_Background_Images/Lake-09.jpg`,
`Header_Background_Images/NYC-07.jpg`,
`Header_Background_Images/Garden-01.jpg`,
`Header_Background_Images/Store-06.jpg`,
`Header_Background_Images/Store-02.jpg`,
`Header_Background_Images/Collegiate-01.jpg`,
`Header_Background_Images/Resort-08.jpg`,
`Header_Background_Images/NYC-03.jpg`,
`Header_Background_Images/NYC-02.jpg`,
`Header_Background_Images/Resort-09.jpg`,
`Header_Background_Images/Store-03.jpg`,
`Header_Background_Images/Store-01.jpg`,
`Header_Background_Images/Collegiate-02.jpg`,
`Header_Background_Images/NYC-01.jpg`,
`Header_Background_Images/Collegiate-03.jpg`,
`Header_Background_Images/Mountain-01.jpg`,
`Header_Background_Images/Americana-07.jpg`,
`Header_Background_Images/Beach-17.jpg`,
`Header_Background_Images/Beach-03.jpg`,
`Header_Background_Images/Country-01.jpg`,
`Header_Background_Images/Beach-02.jpg`,
`Header_Background_Images/Beach-16.jpg`,
`Header_Background_Images/Americana-06.jpg`,
`Header_Background_Images/Mountain-02.jpg`,
`Header_Background_Images/Americana-04.jpg`,
`Header_Background_Images/Beach-28.jpg`,
`Header_Background_Images/Beach-14.jpg`,
`Header_Background_Images/Country-03.jpg`,
`Header_Background_Images/Country-02.jpg`,
`Header_Background_Images/Beach-15.jpg`,
`Header_Background_Images/Beach-01.jpg`,
`Header_Background_Images/Beach-29.jpg`,
`Header_Background_Images/Americana-05.jpg`,
`Header_Background_Images/Mountain-03.jpg`,
`Header_Background_Images/Mountain-07.jpg`,
`Header_Background_Images/Americana-01.jpg`,
`Header_Background_Images/Beach-05.jpg`,
`Header_Background_Images/Beach-11.jpg`,
`Header_Background_Images/Beach-10.jpg`,
`Header_Background_Images/Beach-04.jpg`,
`Header_Background_Images/Mountain-06.jpg`,
`Header_Background_Images/Mountain-04.jpg`,
`Header_Background_Images/Americana-02.jpg`,
`Header_Background_Images/Beach-12.jpg`,
`Header_Background_Images/Beach-06.jpg`,
`Header_Background_Images/Beach-07.jpg`,
`Header_Background_Images/Beach-13.jpg`,
`Header_Background_Images/Americana-03.jpg`,
`Header_Background_Images/Mountain-05.jpg`
  ];

  export const desktopImages = [
    `Header_Background_Images/desktop_bg1.jpg`,
    `Header_Background_Images/desktop_bg2.jpg`,
    `Header_Background_Images/desktop_bg3.jpg`,
    `Header_Background_Images/desktop_bg4.jpg`,
    `Header_Background_Images/desktop_bg5.jpg`,
  ];
